module.exports = __webpack_public_path__ + "static/7-f0c217311a65ffa52a5f78c183c2bcd6.jpg";